import React from "react";
import { Box, Button } from "../../../design-system";
import { LEARNING_CTA } from "../constants/landingText";
import { Image } from "../../../design-system";
import learningImage from "../../../../assets/illustrations/learning-section.svg";

interface LearningImageWithButtonProps {
  onCTAClick: () => void;
}

const LearningImageWithButton: React.FC<LearningImageWithButtonProps> = ({
  onCTAClick,
}) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        maxWidth: "100%",
        height: "auto",
      }}
    >
      <Image
        src={learningImage}
        alt="Learning section illustration"
        objectFit="contain"
        containerProps={{
          sx: {
            width: "100%",
            height: "auto",
          },
        }}
        imageStyle={{
          width: "100%",
          height: "auto",
          display: "block",
          borderRadius: "12px",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: { xs: "15%", md: "10%" },
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 2,
        }}
      >
        <Button
          variant="ghost"
          onClick={onCTAClick}
          sx={{
            padding: { xs: "0.75rem 1.5rem", md: "0.75rem 2rem" },
          }}
        >
          {LEARNING_CTA}
        </Button>
      </Box>
    </Box>
  );
};

export default LearningImageWithButton;
